<template>
  <b-card
    :class="{ 'border-primary': skin === 'dark', 'border-secondary border-lighten-5': skin === 'light' }"
  >
    <div class="d-flex mt-2 text-primary m-2">
      <feather-icon
        icon="LockIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50 text-primary">
        Cuenta
      </h4>
    </div>
    <b-table
      striped
      responsive
      :items="userData.cuentas"
      :fields="tableColumnsCuentas"
      primary-key="id_table_cuenta"
      show-empty
      class="position-relative"
      empty-text="No se encontraron resultados"
    >
      <template #cell(cuenta)="data">
        {{ data.value }}
      </template>
      <template #cell(estado)="data">
        {{ data.value }}
      </template>

    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable,
} from 'bootstrap-vue'
import store from '@/store'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BCard, BTable,
  },
  setup() {
    const skin = computed({
      get: () => store.state.appConfig.layout.skin,
    })
    const tableColumnsCuentas = [
      {
        key: 'cuenta', label: 'Cuenta', sortable: false,
      },
      { key: 'estado', label: 'Estado', sortable: false },
    ]
    return {
      tableColumnsCuentas,
      skin,
    }
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>
